// extracted by mini-css-extract-plugin
export default {"sizes":"tvWlD","column":"z0zJQ","size":"jzbfd","last":"tDO_0","sizeX":"fB8rZ","title":"D5ae3","value":"g1b9r"};